export default {
  item_id: 'number',
  bid_id: 'number',
  bid_amt: 'number',
  user_id: 'number',
  anon: 'number'
}



// WEBPACK FOOTER //
// ./src/store/models/bid.js